'use client';

// QueryType import 제거 (로컬 SelectableType 사용)

interface QueryTypePickerProps {
    onSelect: (type: SelectableType) => void;
}

// AMBIGUOUS와 COMPLEX는 UX 선택지에서 제외 (자동 처리 or 분해)
type SelectableType = 'TABLE_QUERY' | 'VECTOR_SEARCH' | 'DEEP_QUERY';

const TYPES: SelectableType[] = ['TABLE_QUERY', 'VECTOR_SEARCH', 'DEEP_QUERY'];

const ICONS: Record<SelectableType, string> = {
    TABLE_QUERY: '💰',
    VECTOR_SEARCH: '🔍',
    DEEP_QUERY: '📄',
};

const LABELS: Record<SelectableType, string> = {
    TABLE_QUERY: '보험료 / 금액 조회',
    VECTOR_SEARCH: '여러 회사 비교 검색',
    DEEP_QUERY: '특정 약관 심층 분석',
};

const DESCRIPTIONS: Record<SelectableType, string> = {
    TABLE_QUERY:   '특정 상품의 보험료, 해지환급금 등 정확한 금액을 조회합니다.',
    VECTOR_SEARCH: '여러 보험사 약관에서 관련 내용을 찾아 비교합니다.',
    DEEP_QUERY:    '특정 보험 약관을 AI가 정밀하게 분석합니다. (최대 3분 소요)',
};

export default function QueryTypePicker({ onSelect }: QueryTypePickerProps) {
    return (
        <div className="p-4 space-y-3">
            <div className="text-sm font-semibold text-gray-600 mb-1">
                질문을 어떻게 도와드릴까요?
            </div>
            {TYPES.map((type) => (
                <button
                    key={type}
                    onClick={() => onSelect(type)}
                    className="w-full flex items-start gap-3 p-3.5 rounded-xl border border-gray-200 hover:border-blue-400 hover:bg-blue-50 text-left transition-all group"
                >
                    <span className="text-xl mt-0.5 flex-shrink-0">{ICONS[type]}</span>
                    <div>
                        <div className="font-semibold text-sm text-gray-800 group-hover:text-blue-700">
                            {LABELS[type]}
                        </div>
                        <div className="text-xs text-gray-500 mt-0.5">
                            {DESCRIPTIONS[type]}
                        </div>
                    </div>
                </button>
            ))}
        </div>
    );
}
